import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react'

type ThemeVersion = 'v7' | 'v8'

interface ThemeContextProps {
    version: ThemeVersion
    setVersion: (version: ThemeVersion) => void
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined)

const THEME_VERSION_KEY = 'theme_version'

export const ThemeProvider = ({children}: {children: ReactNode}) => {
    const [version, setVersionState] = useState<ThemeVersion>('v8')

    useEffect(() => {
        const storeVersion = localStorage.getItem(THEME_VERSION_KEY) as ThemeVersion | null
        if (storeVersion === 'v7' || storeVersion === 'v8') setVersionState(storeVersion)
    }, [])

    useEffect(() => {
        document.body.setAttribute('data-theme', version)
    }, [version])

    const setVersion = (newVersion: ThemeVersion) => {
        setVersionState(newVersion)
        localStorage.setItem(THEME_VERSION_KEY, newVersion)
        document.body.setAttribute('data-theme', newVersion)
    }

    return <ThemeContext.Provider value={{version, setVersion}}>{children}</ThemeContext.Provider>
}

export const useThemeVersion = (): ThemeContextProps => {
    const context = useContext(ThemeContext)
    if (!context) {
        throw new Error('useThemeVersion must be used within ThemeProvider')
    }
    return context
}
